import React from 'react';

import type {
  PaymentMethodChannelType,
  PaymentMethodChannelUiConfig,
} from '../../../services/commonCheckout/types/SessionConfig/PaymentMethodChannel';
import IconRenderer from '../../../ui/Icons/IconRenderer';

const PaymentMethodChannelConfig: Record<
  Exclude<PaymentMethodChannelType, 'GOOGLE_PAY' | 'APPLE_PAY'>,
  PaymentMethodChannelUiConfig
> = {
  TEXT: {
    icon: (
      <IconRenderer
        name="textsmsOutlined"
        testId="payment-method-channel-text-icon"
      />
    ),
    title: 'Send a link via text',
  },
  EMAIL: {
    icon: (
      <IconRenderer
        name="emailOutlined"
        testId="payment-method-channel-email-icon"
      />
    ),
    title: 'Send a link via email',
  },
  WEBFORM: {
    icon: (
      <IconRenderer
        name="devicesOutlined"
        testId="payment-method-channel-webform-icon"
      />
    ),
    title: 'On-screen entry',
  },
  TELEPHONIC_ENTRY: {
    icon: (
      <IconRenderer
        name="phoneInTalk"
        testId="payment-method-channel-telephonic-entry-icon"
      />
    ),
    title: 'Phone entry',
  },
  TERMINAL: {
    icon: (
      <IconRenderer
        name="paymentOutlined"
        testId="payment-method-channel-terminal-icon"
      />
    ),
    title: 'Terminal entry',
  },
};

export default PaymentMethodChannelConfig;
